import { LoungeGameSettingsScreen } from '@/screens/lounges/LoungeGameSettingsScreen'

export default function LoungeGameSettingsRoute() {
  return <LoungeGameSettingsScreen />
}
